import { Highlight } from "@chakra-ui/react";

export const SearchHighlight = ({ text, term }: { text: string; term?: string | null }) => (
  <Highlight query={term?.trim() ?? ""} styles={{ bg: "smWarningSoft", color: "inherit" }}>
    {text}
  </Highlight>
);
